import { AUTHENTICATION_URL, VALIDATION_PORTAL_LOGIN_URL } from 'common/endpoints/endpoints.constants';
import { DEFAULT_USER } from 'common/mocks/authentication';

const USER_KEY = 'userId';
const SSO_URL = process.env.SSO_URL;

export default class AuthenticationService {

  constructor($http, $cookies, $window, $state, $log, $timeout, AccessTokenService, entryPoint) {
    'ngInject';
    this.$http = $http;
    this.cookies = $cookies;
    this.window = $window;
    this.state = $state;
    this.log = $log;
    this.timeout = $timeout;

    this.accessTokenService = AccessTokenService;
    this.entryPoint = entryPoint;

    this.employeeId = $cookies.get(USER_KEY) ? $cookies.get(USER_KEY) : DEFAULT_USER;
  }

  authenticate(token, target) {
    // this.log.info(('authenticate token ' + token);
    let data = 'token=' + token + '&target=' + target;

    if (process.env.isDev) {
      data += '&employeeId=' + this.employeeId;
    }

    return this.$http({
      method: 'POST',
      url: AUTHENTICATION_URL,
      data: data,
      headers: {
        'Skip-Request': 'true', // Avoid infinite loop!
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then((response) => {
      this.accessTokenService.setToken(response.data.token);
      this.cookies.put(USER_KEY, response.data.employee_id);
      this.employeeId = response.data.employee_id;
      return response;
    });
  }
  
  authenticatePortal(token, employee) {

    return this.$http({
      method: 'GET',
      url: VALIDATION_PORTAL_LOGIN_URL,
      params: {
        'token': token,
        'employeeId': employee
      },
      headers: {
        'Skip-Request': 'true', // Avoid infinite loop!
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then((response) => {
      this.accessTokenService.setToken(response.data.token);
      this.cookies.put(USER_KEY, response.data.employeeId);
      this.employeeId = response.data.employeeId;
      return response;
    });
  }

  isAuthenticated() {
    if (process.env.isDev) {
      return true;
    }

    return (this.cookies.get('token') !== undefined);
  }

  getEmployeeId() {
    return this.employeeId;
  }

  reload() {
    this.window.location.reload();
  }

  redirectToLogin() {
    this.setStorageState();
    const ssoTarget = `${SSO_URL}${this.state.current.name}`;
    this.window.location.href = ssoTarget;
  }

  setStorageState(){
    localStorage.setItem('path', this.window.location.pathname);
  }
  
  pluginLogout() {
    this.clear();
  }
 
  setDefaultToken() {
    this.accessTokenService.setToken('ourSecretToken');
    this.cookies.put(USER_KEY, DEFAULT_USER);
  }

  clear() {
    this.accessTokenService.removeToken();
    //this.window.location.href = `${SSO_URL}index`;
  }

}



// WEBPACK FOOTER //
// ./client/app/common/services/authentication.service.js